import React, {Component,Fragment} from 'react';
import TopNavigation from "../../Components/Common/TopNavigation";
import OrderList from "../../Components/OrderList/OrderList";
import Footer from "../../Components/Common/Footer";
import TopNavigationMobile from "../../Components/Common/TopNavigationMobile";
import FooterMobile from "../../Components/Common/FooterMobile";
import {Redirect} from "react-router";
import SessionHelper from "../../Helper/SessionHelper";

class OrderListPage extends Component {

    constructor() {
        super();
        this.state={
            RedirectWithoutLogin:false,
        }
    }

    pageRedirectWithoutLogin=()=>{
        if(this.state.RedirectWithoutLogin===true){
            return(<Redirect to="/"/>)
        }
    }
    CheckLogin=()=>{
        let Login=SessionHelper.getLogin();
        if(Login!=="YES"){
            this.setState({RedirectWithoutLogin:true})
        }
    }

    componentDidMount() {
        window.scroll(0,0)
        this.CheckLogin();
    }

    render() {
        return (
            <Fragment>
                <TopNavigation/>
                <div className="mobile nav-mobile-top">
                    <TopNavigationMobile/>
                </div>
                <OrderList/>
                <div className="desktop">
                    <Footer/>
                </div>
                <div className="mobile">
                    <FooterMobile/>
                </div>
                {this.pageRedirectWithoutLogin()}
            </Fragment>
        );
    }
}

export default OrderListPage;